<template>
  <div class="keyCode-page">
    <pageHeader />
    <section class="start">
      <div class="right-sec sec min-mobile">
        <div class="content1 auth-center">
          <div class="form-co">
            <div class="info mb-5">
              <h4>{{ $t("auth.pleasephone") }}</h4>
              <p class="gray-col font14">
                {{ $t("auth.codePhase") }}
              </p>
            </div>
            <v-form @submit.prevent="sendCode" ref="form">
              <div class="code-container mb-5">
                <v-otp-input
                  ref="otpInput"
                  input-classes="otp-input"
                  separator=" "
                  :num-inputs="6"
                  v-model="code"
                  :should-auto-focus="true"
                  name="otpInput"
                  :is-input-num="true"
                />
              </div>
              <button
                type="submit"
                :disabled="disabled"
                class="main-btn up xl w-100 mt-4"
              >
                <div v-if="!disabled">{{ $t("auth.confirm") }}</div>
                <div class="loading" role="status" v-if="disabled">
                  {{ $t("auth.confirming") }}
                  <div class="spinner-small-white" v-if="disabled"></div>
                </div>
              </button>
              <div class="flex-bet-main mt-3 font14">
                <div class="have-you gray-col">
                  {{ $t('auth.didnotrecieve') }}
                  <button class="resend-btn" :disabled="disabledBtn || loadingResend" @click="resendCode" type="button">
                    <div>{{ $t('forgetPassCheck.newCode') }}</div>
                  </button>
                </div>
                 <div class="text-center fs15 c-sec" v-if="counterNum > 0">{{ counterText }}</div>
              </div>
            </v-form>
          </div>
        </div>
      </div>
      <welcomeView />
    </section>
  </div>

</template>

<script setup>
import pageHeader from "../components/pageHeader.vue";
import welcomeView from "../components/home/welcomeView.vue";
// Import in a Vue component
import VOtpInput from "vue3-otp-input";
import { ref, onMounted } from "vue";
import { useToast } from "primevue/usetoast";
import { useRouter } from "vue-router";
import axios from "axios";

const toast = useToast();
const router = useRouter();

// const bgGray = ref(require("../assets/imgs/natural-marble-pattern-background.png"))
const otpInput = ref(null);
const disabled = ref(false);
const form = ref(null);


// counter
const counterNum = ref(60);
const counterText = ref('');
const disabledBtn = ref(false);
const loadingResend = ref(false);


function sendCode() {
  disabled.value = true;
  const fd = new FormData(form.value.$el);
  let otpString = JSON.stringify(otpInput.value.otp.join(""));
  let otpsNumber = JSON.parse(otpString);
  fd.append("code", otpsNumber);
  fd.append("phone", localStorage.getItem("phone"));
  fd.append("country_code", localStorage.getItem("country_code"));

  axios.post("/manager/forget-password-check-code", fd).then((response) => {
    if (response.data.key == "success") {
      localStorage.setItem("otpsNumber", otpsNumber);
      toast.add({
        severity: "success",
        detail: `${response.data.msg}`,
        life: 3000,
      });
      router.push("/changePassword");
    } else {
      toast.add({
        severity: "error",
        detail: `${response.data.msg}`,
        life: 3000,
      });
    }
    disabled.value = false;
  });
}
function resendCode() {
  loadingResend.value = true
  const fd = new FormData(form.value.$el);
  fd.append("phone", localStorage.getItem("phone"));
  fd.append("country_code", localStorage.getItem("country_code"));

  axios.post("/manager/forget-password-send-code", fd).then((response) => {
    if (response.data.key == "success") {
      toast.add({
        severity: "success",
        detail: `${response.data.msg}`,
        life: 3000,
      });
      counterNum.value = 60;
      codeCounter();
    } else {
      toast.add({
        severity: "error",
        detail: `${response.data.msg}`,
        life: 3000,
      });
    }
  });

  loadingResend.value = false
}

let counter;
function codeCounter() {
    disabledBtn.value = true;

    counter = setInterval(function () {
        counterNum.value--;
        if (counterNum.value < 60) {
            counterText.value = `${counterNum.value} : 00`;
        }

        if (counterNum.value > 60) {
            counterText.value = `00 : ${counterNum.value}`;
        }

        if (counterNum.value < 10) {
            counterText.value = `0${counterNum.value} : 00`;
        }

        if (counterNum.value == 0) {
            clearInterval(counter);
            disabledBtn.value = false;
        }
    }, 1000);
}

onMounted(() => {
  codeCounter();
});
</script>
